import {Injectable, TemplateRef} from '@angular/core';
import {AppService} from '../../../app.service';
import {FormGroup} from '@angular/forms';
import {IAppRequest, IAppServiceLanguages} from '../../../app.interface';
import {NgxSpinnerService} from 'ngx-spinner';
import {NotifierService} from '@services/notifier.service';
import {MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {FactorRowService} from './factor-row.service';
import {FactorRowDesignerRelationsService} from './factor-row-designer-relations.service';
import {AppHelper} from '../../../core/app.helper';
import {FactorHistoryDialogComponent} from '../dialogs/factor-history-dialog/factor-history-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class FactorRowHistoryService extends AppService {
    className: string = 'FactorRowHistoryService';
    /**
     * Ссылка на диалог
     */
    historyDialogRef: MatDialogRef<any>;
    /**
     * URL страницы
     */
    url = '/factor/front_row';

    /**
     * Получение данных истории изменений по всем записям
     * @param data данные для получения истории
     */
    getAllHistoryData(data: { factor_id: any; language: string; factor_data_id: string; }) {
        return this.http.post<any>(this.serverUrl + this.url + '/get_all_history', data, this._httpOptions);
    }
    /**
     * Получение данных истории изменений
     * @param data данные для получения истории
     */
    getHistoryData(data: { factor_id: any; language: string; type: any; factor_data_id: string; order: number }) {
        return this.http.post<any>(this.serverUrl + this.url + '/get_history', data, this._httpOptions);
    }

    /**
     * Показать историю изменений
     * @param item параметры поля
     * @param form форма
     * @param order порядковый номер для накопительного списка
     * @param options пции для работы диалога
     */
    showRevisionHistory(item: any, form: FormGroup, order: number, options: {
        dialog: MatDialog,
        service: FactorRowService | FactorRowDesignerRelationsService,
        notifier: NotifierService,
        currentLangForm: IAppServiceLanguages
        factorDataId: any,
        spinner: NgxSpinnerService,
        tableData
    }) {
        options.spinner.show();
        this.openDialogHistory({
            factor_data_id: options.factorDataId,
            factor_id: item.id,
            language: options.currentLangForm.lang,
            recordType: typeof options.factorDataId == 'number' ? 'link' : 'main',
            data_type: item.data_type,
            value: form?.value[item?.id]?.data ? form?.value[item?.id]?.data : null,
            tableData: options.tableData ? options.tableData : null
        },
            'one',
            options.dialog);
    }

    /**
     * Открытие диалога отчетов
     * @param data данные
     * @param type тип
     * @param historyDialog ссылка на объект формы
     * @param dialog диалог
     */
    openDialogHistory(data: any, type: string, dialog: MatDialog) {
        const dialogRef = dialog.open(FactorHistoryDialogComponent, {
            disableClose: true,
            autoFocus: false,
            width: '900px',
            data: {
                title: this.language_dictionary.factor_history_of_changes,
                data: {
                    factor_data_id: data.factor_data_id,
                    factor_id: data.factor_id,
                    language: data.language,
                    recordType: data?.recordType,
                    type: data?.data_type,
                    value: data?.value,
                    tableData: data.tableData
                },
                type
            }
        });
        dialogRef.keydownEvents().subscribe(result => {
            if (result.code === 'Escape') {
                dialogRef.close({});
            }
        });
    }
    /**
     * Просмотр всех изменений по карточке реестра
     * @param historyDialog ссылка на объект формы
     * @param dialog диалог
     * @param spinner прелоадер
     * @param notifier сервис всплывающих сообщений
     * @param postData данные для получения истории
     */
    getChangeTracking(
        dialog: MatDialog,
        spinner: NgxSpinnerService, notifier: NotifierService,
        postData: { factor_data_id: string; factor_id: number | string; language: string; }
    ) {
        this.openDialogHistory({
            factor_data_id: postData.factor_data_id,
            factor_id: postData.factor_id,
            language: postData.language
        }, 'full', dialog);
    }

    /**
     * Выгрузка истории изменений в Excel
     * @param spinner прелоадер
     * @param notifier сервис всплывающих сообщений
     * @param postData данные для получения истории
     */
    exportChangeHistory(
        spinner: NgxSpinnerService, notifier: NotifierService,
        postData: {factor_data_id: string; factor_id: number; language: string;}
    ) {
        spinner.show();
        this.downloadService(postData, '/factor/front_row/export_history').toPromise().then((result: any) => {
            AppHelper.createAndDownloadBlobFile(
                result.body,
                {type: result.headers.get('content-type')},
                AppHelper.getHeaderFileName(result.headers)
            );
            spinner.hide();
        }).catch(() => {
            spinner.hide();
            notifier.notify('error', this.language_dictionary.system_no_connection_with_system);
        });
    }
}
